/* eslint-disable import/no-cycle */
import React, { useState } from "react";
import PTMButton from "../PTMButton";
import PTMPasswordCheck from "../PTMPasswordCheck/PTMPasswordCheck";

function PasswordCheckHandler(props) {
    const {
        login, name, setError, isNew,
    } = props;

    const [changePassword, setChangePassword] = useState(isNew);

    return (
        <div>
            {
                changePassword
                    ? (
                        <PTMPasswordCheck
                            login={login}
                            setError={setError}
                            name={name}
                            changePassword
                        />
                    )
                    : (
                        <PTMButton
                            onClick={() => setChangePassword(true)}
                            sx={{ width: "100%" }}
                            variant="contained"
                            color="success"
                        >
                            Passwort ändern
                        </PTMButton>
                    )
            }
        </div>
    );
}

export default PasswordCheckHandler;
